const record = {
  state: {
     addRecordDialog: {
        title:'新增记录信息',
        type:'add'
     },
     recordSearch: {
        stdId:''
     },
     memberList:[],
     recordSearchBtnDisabled: true
  },
  getters:{
    addRecordDialog: state => state.addRecordDialog,
    recordSearch: state => state.recordSearch,
    recordSearchBtnDisabled: state => state.recordSearchBtnDisabled,
  },
  mutations: {
    SET_RECORD_DIALOG_TITLE: (state, type) => {
      // console.log("type:"+type);
      if(type === 'add'){
        state.addRecordDialog.title = '新增记录信息'
        state.addRecordDialog.type = 'add'
      }else{
        state.addRecordDialog.title = '编辑记录信息'
        state.addRecordDialog.type = 'edit'
      }
    },
    SET_RECORD_SEARCH : (state, payload) => {
      // console.log(payload);
       state.recordSearch = payload;
    },
    SET_RECORD_SEARCHBTN_DISABLED : (state, payload) => {
      state.recordSearchBtnDisabled = payload;
    }
  },
  actions: {
  }
}

export default record
